import React, {useEffect, useState} from "react";
import {MessageBody} from "@sendbird/uikit-react/ui/MessageContent";
import useBrowserLanguage from '../utils/useBrowserLanguage';
import {getCustomMessageClass, getRequestObject, mapRequestStatus, requestHeader} from '../utils/messageUtils';
import {useMediaQuery} from "./hooks";
import {RequestActions} from "./RequestActions";

export default function CustomMessageBody(props) {
    const {isByMe, message, channel, conversationId} = props;
    const {customType, metaArrays, data} = message;

    const className = getCustomMessageClass(customType);
    const [requestObject, setRequestObject] = useState(null);
    const [requestStatus, setRequestStatus] = useState(null);
    const requestId = data || conversationId;
    const browserLanguage = useBrowserLanguage();
    const isMobile = useMediaQuery('(max-width: 768px)');

    const renderMessageHeader = () => {
        if (['sample_request', 'pricing_request', 'information_request'].includes(customType)) return (
            <div className={`${className} incoming sendbird-message-header`}>
                <span>{requestHeader(customType)}</span>
                <p>{requestStatus}</p>
            </div>
        );
    };


    useEffect(() => {
        if (customType && customType !== 'ai_assistant' && requestId) {
            getRequestObject(customType, requestId).then((response) => {
                setRequestObject(response);
            });
        }
    }, [customType, requestId]);

    useEffect(() => {
        if (!requestObject) return;
        setRequestStatus(mapRequestStatus(requestObject.status, customType));
    }, [requestObject, customType]);

    if (message.translations && Object.entries(message.translations).length > 0 && message.translations[browserLanguage]) {
        message.message = message.translations[browserLanguage]
    }

    return (
        <div>
            {renderMessageHeader()}
            <MessageBody
                className={`${className} ${metaArrays?.[0] ? "request-actions" : ""}`}
                channel={channel}
                message={message}
                {...props}
            />
            <RequestActions
                requestObject={requestObject}
                requestOptions={metaArrays?.[0]}
                customType={customType}
                requestId={requestId}
                isMobile={isMobile}
                isByMe={isByMe}
            />
        </div>
    );
}
